{
  "actionButtons": {
    "deselectAll": "Déselectionner tout",
    "export": "Export",
    "exportAsCsv": "Export CSV",
    "exportAsPdf": "Export PDF",
    "selectAll": "Sélectionner tout"
  },
  "areYouSureModal": {
    "cancelText": "Annuler",
    "confirmText": "Confirmer",
    "title": "Confirmer l'action"
  },
  "columnManager": {
    "columns": "Colonnes",
    "hiddenColumns": "Colonnes masquées",
    "noColumnsMatch": "Aucune colonne trouvée",
    "pinnedColumns": "Colonnes épinglées",
    "searchPlaceholder": "Rechercher les colonnes...",
    "visibleColumns": "Colonnes visibles"
  },
  "coordinates": {
    "latitude": "Latitude",
    "latitudePlaceholder": "e.g., -48.8566",
    "latitudeTooltip": "Coordonnée géographique spécifiant la position nord-sud de l'adresse du partenaire commercial. Utiliser le format décimal (DD) : les valeurs vont de -90° (pôle Sud) à +90° (pôle Nord)",
    "longitude": "Longitude",
    "longitudePlaceholder": "e.g., 2.3522",
    "longitudeTooltip": "Coordonnée géographique spécifiant la position est-ouest de l'adresse du partenaire commercial. Utiliser le format décimal (DD): les valeurs vont de -180° (vers l'ouest) à +180° (vers l'est)."
  },
  "copy": "{{text}} copié dans le presse-papiers",
  "countries": {
    "AC": "Île de l'Ascension",
    "AD": "Andorre",
    "AE": "Émirats arabes unis",
    "AF": "Afghanistan",
    "AG": "Antigua-et-Barbuda",
    "AI": "Anguilla",
    "AL": "Albanie",
    "AM": "Arménie",
    "AO": "Angola",
    "AQ": "Antarctique",
    "AR": "Argentine",
    "AS": "Samoa américaines",
    "AT": "Autriche",
    "AU": "Australie",
    "AW": "Aruba",
    "AX": "Îles Åland",
    "AZ": "Azerbaïdjan",
    "BA": "Bosnie-Herzégovine",
    "BB": "Barbade",
    "BD": "Bangladesh",
    "BE": "Belgique",
    "BF": "Burkina Faso",
    "BG": "Bulgarie",
    "BH": "Bahreïn",
    "BI": "Burundi",
    "BJ": "Bénin",
    "BL": "Saint-Barthélemy",
    "BM": "Bermudes",
    "BN": "Brunei",
    "BO": "Bolivie",
    "BQ": "Pays-Bas caribéens",
    "BR": "Brésil",
    "BS": "Bahamas",
    "BT": "Bhoutan",
    "BV": "Île Bouvet",
    "BW": "Botswana",
    "BY": "Biélorussie",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Îles Cocos (Keeling)",
    "CD": "Congo-Kinshasa",
    "CF": "République centrafricaine",
    "CG": "Congo-Brazzaville",
    "CH": "Suisse",
    "CI": "Côte d'Ivoire",
    "CK": "Îles Cook",
    "CL": "Chili",
    "CM": "Cameroun",
    "CN": "Chine",
    "CO": "Colombie",
    "CP": "Île Clipperton",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cap-Vert",
    "CW": "Curaçao",
    "CX": "Île Christmas",
    "CY": "Chypre",
    "CZ": "République tchèque",
    "DE": "Allemagne",
    "DG": "Diego Garcia",
    "DJ": "Djibouti",
    "DK": "Danemark",
    "DM": "Dominique",
    "DO": "République dominicaine",
    "DZ": "Algérie",
    "EA": "Ceuta et Melilla",
    "EC": "Équateur",
    "EE": "Estonie",
    "EG": "Égypte",
    "EH": "Sahara occidental",
    "ER": "Érythrée",
    "ES": "Espagne",
    "ET": "Éthiopie",
    "EU": "Union européenne",
    "FI": "Finlande",
    "FJ": "Fidji",
    "FK": "Îles Malouines",
    "FM": "Micronésie",
    "FO": "Îles Féroé",
    "FR": "France",
    "GA": "Gabon",
    "GB": "Royaume-Uni",
    "GD": "Grenade",
    "GE": "Géorgie",
    "GF": "Guyane française",
    "GG": "Guernesey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Groenland",
    "GM": "Gambie",
    "GN": "Guinée",
    "GP": "Guadeloupe",
    "GQ": "Guinée équatoriale",
    "GR": "Grèce",
    "GS": "Géorgie du Sud-et-les Îles Sandwich du Sud",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinée-Bissau",
    "GY": "Guyana",
    "HK": "R.A.S. chinoise de Hong Kong",
    "HM": "Îles Heard-et-MacDonald",
    "HN": "Honduras",
    "HR": "Croatie",
    "HT": "Haïti",
    "HU": "Hongrie",
    "IC": "Îles Canaries",
    "ID": "Indonésie",
    "IE": "Irlande",
    "IL": "Israël",
    "IM": "Île de Man",
    "IN": "Inde",
    "IO": "Territoire britannique de l'océan Indien",
    "IQ": "Irak",
    "IR": "Iran",
    "IS": "Islande",
    "IT": "Italie",
    "JE": "Jersey",
    "JM": "Jamaïque",
    "JO": "Jordanie",
    "JP": "Japon",
    "KE": "Kenya",
    "KG": "Kirghizistan",
    "KH": "Cambodge",
    "KI": "Kiribati",
    "KM": "Comores",
    "KN": "Saint-Kitts-et-Nevis",
    "KP": "Corée du Nord",
    "KR": "Corée du Sud",
    "KW": "Koweït",
    "KY": "Îles Caïmans",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Liban",
    "LC": "Sainte-Lucie",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Libéria",
    "LS": "Lesotho",
    "LT": "Lituanie",
    "LU": "Luxembourg",
    "LV": "Lettonie",
    "LY": "Libye",
    "MA": "Maroc",
    "MC": "Monaco",
    "MD": "Moldavie",
    "ME": "Monténégro",
    "MF": "Saint-Martin",
    "MG": "Madagascar",
    "MH": "Îles Marshall",
    "MK": "Macédoine du Nord",
    "ML": "Mali",
    "MM": "Myanmar (Birmanie)",
    "MN": "Mongolie",
    "MO": "Macao RAS de Chine",
    "MP": "Îles Mariannes du Nord",
    "MQ": "Martinique",
    "MR": "Mauritanie",
    "MS": "Montserrat",
    "MT": "Malte",
    "MU": "Maurice",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexique",
    "MY": "Malaisie",
    "MZ": "Mozambique",
    "NA": "Namibie",
    "NC": "Nouvelle-Calédonie",
    "NE": "Niger",
    "NF": "Île Norfolk",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Pays-Bas",
    "NO": "Norvège",
    "NP": "Népal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Nouvelle-Zélande",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Pérou",
    "PF": "Polynésie française",
    "PG": "Papouasie-Nouvelle-Guinée",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Pologne",
    "PM": "Saint-Pierre-et-Miquelon",
    "PN": "Îles Pitcairn",
    "PR": "Porto Rico",
    "PS": "Territoires palestiniens",
    "PT": "Portugal",
    "PW": "Palaos",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Roumanie",
    "RS": "Serbie",
    "RU": "Russie",
    "RW": "Rwanda",
    "SA": "Arabie saoudite",
    "SB": "Îles Salomon",
    "SC": "Seychelles",
    "SD": "Soudan",
    "SE": "Suède",
    "SG": "Singapour",
    "SH": "Sainte-Hélène",
    "SI": "Slovénie",
    "SJ": "Svalbard et Île Jan Mayen",
    "SK": "Slovaquie",
    "SL": "Sierra Leone",
    "SM": "Saint-Marin",
    "SN": "Sénégal",
    "SO": "Somalie",
    "SR": "Suriname",
    "SS": "Soudan du Sud",
    "ST": "São Tomé-et-Principe",
    "SV": "El Salvador",
    "SX": "Saint-Martin (partie néerlandaise)",
    "SY": "Syrie",
    "SZ": "Eswatini",
    "TA": "Tristan da Cunha",
    "TC": "Îles Turks-et-Caïcos",
    "TD": "Tchad",
    "TF": "Terres australes françaises",
    "TG": "Togo",
    "TH": "Thaïlande",
    "TJ": "Tadjikistan",
    "TK": "Tokelau",
    "TL": "Timor oriental",
    "TM": "Turkménistan",
    "TN": "Tunisie",
    "TO": "Tonga",
    "TR": "Turquie",
    "TT": "Trinité-et-Tobago",
    "TV": "Tuvalu",
    "TW": "Taïwan",
    "TZ": "Tanzanie",
    "UA": "Ukraine",
    "UG": "Ouganda",
    "UM": "Îles mineures éloignées des États-Unis",
    "UN": "Inconnu",
    "US": "États-Unis",
    "UY": "Uruguay",
    "UZ": "Ouzbékistan",
    "VA": "Cité du Vatican",
    "VC": "Saint-Vincent-et-les Grenadines",
    "VE": "Venezuela",
    "VG": "Îles Vierges britanniques",
    "VI": "Îles Vierges des États-Unis",
    "VN": "Viêt Nam",
    "VU": "Vanuatu",
    "WF": "Wallis-et-Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yémen",
    "YT": "Mayotte",
    "ZA": "Afrique du Sud",
    "ZM": "Zambie",
    "ZW": "Zimbabwe"
  },
  "countriesEcobalyse": {
    "BD": "Bangladesh",
    "CN": "Chine",
    "FR": "France",
    "IN": "Inde",
    "KH": "Cambodge",
    "MA": "Maroc",
    "MM": "Myanmar",
    "PK": "Pakistan",
    "RAF": "Région - Afrique",
    "RAS": "Région - Asie",
    "REE": "Région - Europe de l'Est",
    "REO": "Région - Europe de l'Ouest",
    "RLA": "Région - Amérique Latine",
    "RME": "Région - Moyen-Orient",
    "RNA": "Région - Amérique du nord",
    "ROC": "Région - Océanie",
    "TN": "Tunisie",
    "TR": "Turquie",
    "VN": "Vietnam"
  },
  "dataLoad": {
    "error": {
      "message": "Nous n'avons pas pu récupérer les données demandées. Merci de recharger la page.",
      "title": "Une erreur est survenue"
    },
    "noResults": {
      "message": "Nous n'avons trouvé aucune donnée liée à votre entreprise. Merci de réessayer plus tard.",
      "title": "Aucun résultat"
    }
  },
  "documentUpload": {
    "helptext": "Taille maximale: {{ maxSize }}MB",
    "missingDocument": "Impossible de trouver le document",
    "title": "Déposez vos fichiers ici ou cliquez pour les sélectionner manuellement",
    "uploadSuppliers": "Valider"
  },
  "error": {
    "default": "Une erreur est survenue",
    "message": "message",
    "title": "title"
  },
  "fabricProcess": {
    "knitting-circular": "Tricotage circulaire",
    "knitting-fully-fashioned": "Tricotage fully-fashioned",
    "knitting-integral": "Tricotage intégral",
    "knitting-mix": "Tricotage mixte",
    "knitting-straight": "Tricotage droit",
    "weaving": "Tissage"
  },
  "filter": "Filtres",
  "filter_false": "Non",
  "filter_true": "Oui",
  "form": {
    "reset": "Réinitialiser",
    "save": "Enregistrer"
  },
  "languages": {
    "arabic": "Arabe",
    "belarusian": "Biélorusse",
    "chinese": "Chinois",
    "dutch": "Néerlandais",
    "english": "Anglais",
    "french": "Français",
    "german": "Allemand",
    "italian": "Italien",
    "japanese": "Japonais",
    "korean": "Coréen",
    "lithuanian": "Lituanien",
    "portuguese": "Portuguais",
    "romanian": "Roumain",
    "spanish": "Espagnol",
    "turkish": "Turc"
  },
  "lists": {
    "noData": {
      "title": "Aucune donnée"
    }
  },
  "menus": {
    "admin": "Administration",
    "businessPartners": "Partenaires commerciaux",
    "certificates": "Documents",
    "communicationStudio": "Studio : façonner et contrôler la présentation des informations collectées à vos consommateurs finaux. Il permet de gérer le contenu du passeport ou de la fiche produit, configurer les traductions, définir la mise en page et établir des règles dynamiques afin de préserver l’image de marque et garantir une narration omnicanale cohérente à travers vos outils.",
    "dashboard": "Tableau de bord",
    "dataTransfer": "Ressources",
    "faq": "FAQ",
    "invoices": "Mes factures",
    "logout": "Se déconnecter",
    "products": "Catalogue",
    "profile": "Mon profil",
    "regulations": "Règlementations"
  },
  "showOnlyMainFabric": "Composant principal",
  "simulation": {
    "notSubscribed": {
      "message": "message",
      "title": "title"
    }
  },
  "sort": {
    "ascending": "Ascendant",
    "descending": "Descendant",
    "search": {
      "placeholder": "Rechercher"
    },
    "title": "Trier"
  },
  "success": {
    "message": "Action réussie",
    "title": "Succès"
  },
  "supplier": {
    "footer": {
      "privacyPolicy": "Politique de confidentialité"
    },
    "menu": {
      "contacts": "Partenaires",
      "documentation": "Documentation",
      "loggedAs": "Vous êtes connecté en tant que",
      "productionSites": "Sites",
      "requests": "Requêtes",
      "supplierRequests": "Fournisseurs"
    }
  },
  "table": {
    "filter": {
      "date": {
        "preset": {
          "custom": "Choisir une date",
          "oneMonthAgo": "Il y a un mois",
          "oneMonthFromNow": "Dans un mois",
          "oneWeekAgo": "Il y a une semaine",
          "oneWeekFromNow": "Dans une semaine",
          "oneYearAgo": "Il y a un an",
          "oneYearFromNow": "Dans un an",
          "today": "Aujourd'hui",
          "tomorrow": "Demain",
          "yesterday": "Hier"
        }
      },
      "operator": {
        "after": "Est après le",
        "afterOrEquals": "Est le ou après le",
        "before": "Est avant le",
        "beforeOrEquals": "Est le ou avant le",
        "between": "Est compris dans la période",
        "empty": "Est vide",
        "equals": "Est le",
        "isEmpty": "isEmpty",
        "isNotEmpty": "isNotEmpty",
        "notBetween": "N'est pas compris dans la période",
        "notEmpty": "N'est pas vide",
        "notEquals": "N'est pas le"
      }
    },
    "hideColumn": "Masquer",
    "manageColumns": "Gérer les colonnes",
    "noDataMessage": "Aucune donnée à afficher",
    "noDataTitle": "Aucun résultat trouvé",
    "pinColumn": "Épingler",
    "rowsPerPage": "Lignes par page",
    "showColumn": "Afficher",
    "total": "Total: ",
    "unpinColumn": "Libérer",
    "views": {
      "add": {
        "error": {
          "message": "Erreur lors de la création de la vue",
          "title": "Erreur lors de la création de la vue"
        },
        "success": {
          "message": "Vue créée avec succès",
          "title": "Vue créée"
        }
      },
      "delete": {
        "error": {
          "message": "Erreur lors de la suppression de la vue",
          "title": "Erreur lors de la suppression de la vue"
        },
        "modal": {
          "cancel": "Annuler",
          "delete": "Supprimer",
          "description": "Voulez-vous vraiment supprimer la vue {{viewName}} ? Cette action est irrévocable.",
          "title": "Confirmation"
        },
        "success": {
          "message": "Vue supprimée avec succès",
          "title": "Vue supprimée"
        }
      },
      "modal": {
        "description": "Enregistrez la vue active de la table de données pour y accéder ultérieurement. Le tri, le filtrage et la configuration des colonnes seront sauvegardés.",
        "pinnedToDashboard": {
          "label": "Agrafer au tableau de bord",
          "tooltip": "Un raccourci ajouté à la section Spotlights du tableau de bord permettra d'accéder en un clic a cette vue."
        },
        "reset": "Réinitialiser",
        "save": "Enregistrer (bêta)",
        "title": "Vue active (bêta)",
        "update": "Mettre à jour"
      },
      "update": {
        "error": {
          "message": "Erreur lors de la mise à jour de la vue",
          "title": "Erreur lors de la mise à jour de la vue"
        },
        "success": {
          "message": "Vue mise à jour avec succès",
          "title": "Vue mise à jour"
        }
      },
      "viewName": "Nom",
      "viewNamePlaceholder": "Entrez le nom de la vue"
    }
  },
  "zodErrors": {
    "errorDefault": "Valeur invalide",
    "invalidEmail": "Adresse email non valide",
    "latitudeOutOfRange": "La latitude doit être comprise entre -90 et +90",
    "longitudeOutOfRange": "La longitude doit être comprise entre -180 et +180",
    "mustContainBothLatitudeAndLongitude": "Il faut fournir la latitude et la longitude",
    "noSpecialCharacters": "La valeur doit contenir plus de 2 caractères et ne doit pas contenir de caractères spéciaux",
    "ValueTooLong": "Valeur trop longue",
    "ValueTooShort": "Valeur trop courte"
  }
}
